import { useEffect, useState } from "react";
import "../css/guides.css";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import MerlinDB from "@chrisaxxwell/merlin-db";
import { GuidesContainer, useSharedGuides } from "./guides";
import axios from "axios";
import { updateContent } from "./admin";
import Head from "./head";

var merlin = new MerlinDB();
merlin.connect("merlinDB");

var schemaGuides = merlin.Schema({
   name: String,
   content: Object
});

function specialChars(str) {
   const charMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '(': '&lpar;',
      ')': '&rpar;',
      '{': '&lbrace;',
      '}': '&rbrace;'
   };

   return str.replace(/[&<>}){(]/g, match => charMap[ match ] || match);
}

function Access({ data }) {
   var ref = '/manual/reference/';

   return (
      <div className="access">
         {
            data.slice(0, 3).map((e, i) => (
               <Link key={i}
                  className={
                     (i === 1 && data.length !== 2)
                        || (data.length === 2 && i === 0) ? "in" : null}
                  to={ref + e.to}>{e.name}
               </Link>
            ))
         }
      </div>
   )
}

function transformCode(line) {
   var comment = /(.*)(\/\/[^]+)/;
   var isComment = comment.test(line);
   var commented = "";

   line = line.replace(/e[\s]?=>[\s]?/g, "e => ");

   if (!isComment) {
      line = specialChars(line);
   }

   line = line.replace(comment, "$1<li class='comment'>$2</li>");
   line = line.replace(/\/\*([^]+)\*\//, "<li class='comment'>/* $1 */</li>");


   line = line.split("  ").join("&nbsp;&nbsp;");

   if (isComment) {
      var index = line.indexOf("//");
      commented = line.slice(index);
      line = line.slice(0, index);
   }

   line = line.replace(/(&lbrace;|&rbrace;|\[])/g, "<li class='schema5'>$1</li>");
   line = line.replace(/(["'\w$]+):/g, "<li class='schema3'>$1:</li>");
   line = line.replace(/(\snew|^import|\sfrom\s|^npm\b|^await|^async)/g, "<li class='schema2'>$1</li>");
   line = line.replace(/\b(Number|Function|String|true|false|\d+|Object|Array|Date)\b/g, "<li class='schema4'>$1</li>");
   line = line.replace(/(.\w+&lpar;|&rpar;|const|\bvar|\blet|src=|\binstall|function &lpar;)/g, "<li class='schema1'>$1</li>");
   line = line.replace(/(COLLECTION:)/g, "<li class='schema4'>$1</li>");
   line += commented;
   return line;
}

function CreateCode({ content, edit }) {
   return (
      <table>
         <tbody>{
            content.trim().split("\n").map((e, i) => (
               <tr key={i}>
                  <td>{i + 1}</td>
                  <td dangerouslySetInnerHTML={{ __html: transformCode(e) }} />
               </tr>
            ))
         }</tbody>
      </table>
   )
}

function defineStyle(text) {
   text = text || "";
   text = text.replace(/&\*([^&]+)&#\[disappear-1\]/gi, "<li data-disappear-1='$1'></li>");
   text = text.replace(/&\*([^&]+)&#\[disappear-2\]/gi, "<li data-disappear-2='$1'></li>");
   text = text.replace(/&\*([^&]+)&#\[disappear-3\]/gi, "<li data-disappear-3='$1'></li>");
   text = text.replace(/&\*([^&]+)&#\[disappear-4\]/gi, "<li data-disappear-4='$1'></li>");

   text = text.replace(/&\*([^&]+)&#\[lilit\]/gi, "<li data-disappear=' (Be careful for no reason use the {{ lilit }} method, dont look for it, or use it, you can...)'>$1</li>");
   text = text.replace(/\*\*([^*]+)\*\*\[schema1\]/gi, "<strong class='schema1'>$1</strong>");
   text = text.replace(/\*\*([^*]+)\*\*\[schema2\]/gi, "<strong class='schema2'>$1</strong>");
   text = text.replace(/\*\*([^*]+)\*\*\[schema3\]/gi, "<strong class='schema3'>$1</strong>");
   text = text.replace(/\*\*([^*]+)\*\*\[schema4\]/gi, "<strong class='schema4'>$1</strong>");
   text = text.replace(/\[note\]\*\*([^*]+)\*\*/gi, "<span class='color-note'>$1</span>");
   text = text.replace(/\*\*([^*]+)\*\*/gi, "<strong>$1</strong>");
   text = text.replace(/\*([^*]+)\*/gi, "<i>$1</i>");
   text = text.replace(/\[([^]+)\]\(([^]+)\)\(([^]+)\)\[route\]/gi, "<a href='$2' to='$3' link-react>$1</a>");
   text = text.replace(/\[([^\]]+?)\]\(([^].+?)\)\[([^].+?)\]/gi, "<a href='$2' target='$3'>$1</a>");
   text = text.replace(/\[([^]+)\]\(([^]+)\)/gi, "<a href='$2'>$1</a>");

   return text;
}

function unmakeStyle(txt) {
   txt = txt.replace(/(\[[^]+?\])|(\*\*|&#|&\*)/gi, "");
   txt = txt.replace(/(\s\s)/gi, " ");
   return txt.trim();
}

function Creators() {
   return this;
}

Creators.prototype.h1 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h1 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.starting = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h1 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} className="title-ref" />
   )
}

Creators.prototype.description = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h2 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} className="description-ref" />
   )
}

Creators.prototype.h2 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);

   return (
      <h2 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.h3 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h3 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.h4 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h4 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.space = function ({ key }) {
   return (
      <span key={key} className="space"></span>
   )
}

Creators.prototype.h5 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h5 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.h6 = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <h6 onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.p = function ({ content, key, edit, tag }) {
   content = defineStyle(content);
   return (
      <p onBlur={edit ? (e) => {
         updateContent(tag, e.target.innerHTML);
      } : null} onKeyUp={edit ? (e) => {
         if (e.target.textContent === '') {
            e.target.textContent = 'Aa'
         }
      } : null} contentEditable={edit} dangerouslySetInnerHTML={{ __html: content }} key={key} />
   )
}

Creators.prototype.br = function ({ key }) {
   return (
      <br key={key}></br>
   )
}

Creators.prototype.access = function ({ content, key }) {
   return (
      <Access data={content} key={key} />
   )
}

var creator = new Creators();

function setGuidesAnimation() {
   var guides = document.getElementById("guides");
   guides.classList.remove("guides-animation");

   var timer = null;
   clearTimeout(timer)
   timer = setTimeout(() => {
      guides.classList.add("guides-animation");
   }, 500);
}

function getDataGuides(id) {
   var contentModel = merlin.model("guides-content", schemaGuides);

   return new Promise((resolve, reject) => {

      merlin.getModel("guides-content").then(e => {

         contentModel.findOne({ name: id }).then(e => {
            resolve(e.content);
         });

      }).catch(async e => {
         var { data } = await axios.get("/json/guides-content-en.json");

         contentModel.insert(data).then(e => {

            contentModel.findOne({ name: id }).then(e => {
               resolve(e.content)
            });

         }).catch(e => { })
      })
   });
}

export default function Reference() {
   var navigate = useNavigate();
   var { id } = useParams();
   var [ param ] = useSearchParams();
   var [ edit, setEdit ] = useState(false);
   var { guides, defineGuides, setGuides } = useSharedGuides();
   var [ prov, setProv ] = useState(false);

   useEffect(() => {
      setGuides([]);
      defineGuides();

      window.onclick = e => {
         var ref = e.target;

         if (ref.hasAttribute('link-react')) {
            e.preventDefault();
            navigate(ref.getAttribute('to'));
         }
      }

   }, []);

   useEffect(e => {
      setEdit(null);

      setTimeout(() => {
         var noDataFoundedTimer = null;

         clearTimeout(noDataFoundedTimer);
         noDataFoundedTimer = setTimeout(() => {
            setProv('noData')
         }, 2000);

         getDataGuides(id).then(e => {
            if (e) {
               clearTimeout(noDataFoundedTimer);
            }
            setProv(e);
         });

         window.scrollTo(0, 0);
      }, 400);

      if (param.get("edit") && window.localStorage.getItem("access-token")) {
         setEdit(true);

         setTimeout(() => {

            var contentEditable = document.querySelector("h1");
            contentEditable && contentEditable.focus()
         }, 500);
      }
      setGuidesAnimation();
   }, [ id, param ]);

   const allData = guides.flatMap(item => item.data);
   allData.unshift({ name: "Guides", to: "../../guides" });

   const notObjects = allData.reduce((acc, curr, index, array) => {

      if (curr.to === id) {
         const start = Math.max(0, index - 1);
         const end = Math.min(array.length, index + 2);

         for (let i = start; i < end; i++) {
            acc.push(array[ i ]);
         }
      }

      return acc;
   }, []);

   return (

      <main id="guides" className="refs guides-animation">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "article",
            title: `${prov && prov.starting ? unmakeStyle(prov.starting) : prov && prov.h1 ? unmakeStyle(prov.h1) : "MerlinDB"} - MerlinDB`,
            description: `${prov && prov.description ? unmakeStyle(prov.description) : prov && prov.h2 ? unmakeStyle(prov.h2) : "MerlinDB the indexedDB API database based on MongoDB.'Alakazam'."}`,
            page_author: "Chris Axxwell",
            index: "index, follow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "/manual/reference/" + id,
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />

         <div id="top-guides">
            <button onPointerDown={(e) => {
               e.target.closest("#top-guides").className = "show";
            }}>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" version="1.1">
                  <path d="M16.1169374,10.2515396 C17.7037773,10.2564483 18.9903314,11.5658018 19,13.185694 L19,13.185694 L19,16.0568451 C18.9903739,17.6782168 17.7052045,18.9901732 16.1169374,19 L16.1169374,19 L13.3044084,19 C11.7175906,18.9901299 10.4349709,17.6767599 10.4301624,16.0568451 L10.4301624,16.0568451 L10.4301624,13.185694 C10.4301624,11.5652052 11.7170062,10.2515396 13.3044084,10.2515396 L13.3044084,10.2515396 Z M4.03805104,10.251554 C4.33336015,10.2192801 4.62080553,10.3619313 4.77835184,10.618945 C4.93589815,10.8759586 4.93589815,11.2022322 4.77835184,11.4592459 C4.62080553,11.7162595 4.33336015,11.8589108 4.03805104,11.8266369 L4.03805104,11.8266369 L2.88306265,11.8266369 C2.14635371,11.8266206 1.5477702,12.4336604 1.54292343,13.1857084 L1.54292343,13.1857084 L1.54292343,16.0208576 C1.56165621,16.7668724 2.15217202,17.3657305 2.88306265,17.3799291 L2.88306265,17.3799291 L5.71322506,17.3799291 C6.06783888,17.3823266 6.4087354,17.2401982 6.66031694,16.9850625 C6.91189848,16.7299268 7.05337205,16.3828707 7.05336427,16.0208576 L7.05336427,16.0208576 L7.05336427,11.7636336 L7.04133103,11.6577296 C7.02803,11.3760616 7.16312386,11.1047905 7.4008667,10.9509055 C7.66832739,10.7777849 8.01201204,10.787984 8.26916976,10.976673 C8.52632747,11.1653621 8.64533537,11.4946628 8.56983759,11.8086359 L8.56983759,11.8086359 L8.56983759,16.047859 C8.56983759,17.6733186 7.27904647,18.9910139 5.68677494,18.9910139 L5.68677494,18.9910139 L2.88306265,18.9910139 C1.30455556,18.9575814 0.0327499024,17.6592673 -2.30926389e-14,16.047859 L-2.30926389e-14,16.047859 L-2.30926389e-14,13.1857084 C-2.30926389e-14,12.4059603 0.304027858,11.6582794 0.844961927,11.1077593 C1.385896,10.5572391 2.11923877,10.2491621 2.88306265,10.251554 L2.88306265,10.251554 Z M16.1169374,11.8266225 L13.3044084,11.8266225 C12.5691392,11.8266225 11.9730562,12.4350995 11.9730562,13.185694 L11.9730562,13.185694 L11.9730562,16.0568451 C11.9707192,16.4180285 12.110223,16.7651192 12.3604092,17.0205202 C12.6105955,17.2759211 12.9505994,17.4183327 13.3044084,17.4159469 L13.3044084,17.4159469 L16.1169374,17.4159469 C16.4707463,17.4183327 16.8107502,17.2759211 17.0609365,17.0205202 C17.3111227,16.7651192 17.4506266,16.4180285 17.4482895,16.0568451 L17.4482895,16.0568451 L17.4482895,13.185694 C17.4482895,12.8252458 17.3079959,12.4795606 17.0583245,12.2246853 C16.8086531,11.9698099 16.470026,11.8266225 16.1169374,11.8266225 L16.1169374,11.8266225 Z M16.1169374,2.66453526e-14 C17.6920006,0.0381794262 18.9586076,1.33515287 18.9911833,2.9431549 L18.9911833,2.9431549 L18.9911833,5.80530554 C19.0005942,6.58350892 18.7067619,7.33364943 18.1743377,7.89067465 C17.6419136,8.44769986 16.9145199,8.76597193 16.1522042,8.77546187 L16.1522042,8.77546187 L14.9883991,8.77546187 C14.5941202,8.73237171 14.2951195,8.39271731 14.2951195,7.98792042 C14.2951195,7.58312353 14.5941202,7.24346912 14.9883991,7.20037897 L14.9883991,7.20037897 L16.1169374,7.20037897 C16.4739098,7.19801311 16.8152051,7.05035361 17.0651331,6.79014731 C17.3150612,6.52994101 17.4529645,6.17869498 17.4482599,5.81430602 L17.4482599,5.81430602 L17.4482599,2.9431549 C17.4387613,2.19661376 16.8482359,1.59377993 16.1169374,1.58408337 L16.1169374,1.58408337 L13.3044084,1.58408337 C12.5691392,1.58408337 11.9730858,2.19256042 11.9730858,2.9431549 L11.9730858,2.9431549 L11.9730858,7.23638086 L11.9626058,7.34316049 C11.8994696,7.72660372 11.5706896,8.01513394 11.1795824,8.0104216 C10.9745563,8.00573523 10.7799061,7.91743274 10.6390951,7.76523113 C10.498284,7.61302951 10.4230394,7.40960459 10.4301624,7.20037897 L10.4301624,7.20037897 L10.4301624,2.9431549 C10.4278194,2.16341049 10.7296062,1.41478251 11.268886,0.862573639 C11.8081659,0.310364772 12.5405809,2.66453526e-14 13.3044084,2.66453526e-14 L13.3044084,2.66453526e-14 Z M5.6955917,1.02140518e-13 C7.2858537,0.00494191606 8.57381333,1.31974675 8.57865434,2.9431549 L8.57865434,2.9431549 L8.57865434,5.81430602 C8.57865434,6.5940541 8.27462648,7.341735 7.73369241,7.89225515 C7.19275835,8.44277531 6.45941557,8.75085231 5.6955917,8.74847427 L5.6955917,8.74847427 L2.88306269,8.74847427 C1.29622272,8.74355173 0.009668661,7.43419818 4.84918523e-08,5.81430602 L4.84918523e-08,5.81430602 L4.84918523e-08,2.9431549 C0.00962617479,1.32178316 1.29479552,0.0098267656 2.88306269,1.02140518e-13 L2.88306269,1.02140518e-13 Z M5.6955917,1.58408337 L2.88306269,1.58408337 C2.52541369,1.57682822 2.17995161,1.7168064 1.92453001,1.97247235 C1.66910841,2.2281383 1.52521947,2.57797928 1.52529007,2.9431549 L1.52529007,2.9431549 L1.52529007,5.81430602 C1.51801794,6.18414129 1.65873212,6.54102414 1.91495728,6.80258985 C2.17118243,7.06415556 2.52077858,7.20780267 2.88306269,7.20037897 L2.88306269,7.20037897 L5.6955917,7.20037897 C6.05256418,7.19801311 6.39385944,7.05035361 6.64378748,6.79014731 C6.89371552,6.52994101 7.03161883,6.17869498 7.0269142,5.81430602 L7.0269142,5.81430602 L7.0269142,2.9431549 C7.02210573,2.1946031 6.42885984,1.58899207 5.6955917,1.58408337 L5.6955917,1.58408337 Z" />
               </svg>
               Guides
            </button>
            <div>
               <div>
                  <GuidesContainer guides={guides} id={id} />
               </div>
            </div>
            <span className="glass" onPointerDown={(e) => {
               e.target.closest("#top-guides").className = "";
            }}></span>
         </div>

         <Access data={notObjects} />
         {
            prov && typeof prov !== 'string' ?
               Object.entries(prov).map(([ key, value ], index) =>
                  key.indexOf('code') !== -1 ? (
                     <code key={index} >
                        <CreateCode content={value} edit={edit} tag={{ key, id }} />
                     </code>
                  ) : (
                     creator[ key.split("-")[ 0 ] ]({ content: value, key: index, edit: edit, tag: { key, id } })
                  )
               )
               : prov === 'noData' ? <p>'{id}' content not found!</p> : <div className="no-guides lazy-mask">
                  <p>-----------------------------------------------------------------------</p>
                  <p>--------------------------</p>
                  <p>-----------------------------</p>
                  <p>---------</p>
                  <p>----------------------------------- --------------------</p>
                  <p>---------------------------------------</p>
                  <p>--------------</p>
                  <p>--------------------------------------------------</p>
                  <p>-------------</p>
                  <p>-----------------------</p>
                  <p>------</p>
               </div>
         }

         <div id="pagination">
            {notObjects.map((e, i) => (
               i === 0 ? (
                  <Link key={i} to={"/manual/reference/" + e.to}><strong>⇜ </strong>{e.name}</Link>
               ) : i === 2 || notObjects.length === 2 ? (
                  <Link key={i} to={"/manual/reference/" + e.to}>{e.name}<strong> ⇝</strong></Link>
               ) : null
            ))}
         </div>
         <Access data={notObjects} />
      </main >
   )
}

export { CreateCode, setGuidesAnimation, defineStyle, schemaGuides }